import type { components } from "@/api-schema";
import { DmsSystem } from "@/api-schema-enums";

type Customer = components["schemas"]["Customer"];

export function getCustomerSapIdentifier(customer: Pick<Customer, "customerIdentifiers">): string | undefined {
  return customer.customerIdentifiers?.find((identifier) => identifier.type === DmsSystem.Sap)?.identifier;
}
